module.exports = __webpack_public_path__ + "img/BNDCR-G.cb7d473a.png";